import React from 'react';
import { Col, FormGroup } from 'reactstrap';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import { loadContentTraining as loadText } from './../../../utils/Api';
import ListComponent from '../../ListComponent';
import Pagination from '../../../components/_Pagination';
import { loadContentsTraining, loadContentTraining } from '../../../actions/contentsTraining';
import { addModal } from '../../../actions/modals';
import store from '../../../store';
import { getTextFromHtml, toHHMMSS } from '../../../utils/helper';

const mapStateToProps = ({ user, contentsTraining }) => ({
  permissions: user.permissions || [],
  list: contentsTraining.list,
  total: contentsTraining.total,
  content: contentsTraining.content,
});
const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      loadItems: loadContentsTraining,
      loadContentTraining,
    },
    dispatch,
  );
class ContentsTraining extends ListComponent {
  getListParams() {
    const params = {
      limit: this.state.items,
    };

    if (this.state.page !== 1) {
      params.offset = (this.state.page - 1) * this.state.items;
    }

    const type = this.props.match.path.split('/').slice(-1).pop();

    if (
      ['text', 'link', 'audio', 'video', 'image', 'document'].includes(type)
    ) {
      params.type = type;
    }

    return params;
  }

  reload() {
    this.initState();
    this.props.loadItems(+this.props.match.params.id, this.getListParams());
  }

  getPreview(item, width = 640, height = 480, full = false) {
    this.fileOutput = <span />;
    switch (item.type) {
      case 'image':
        this.fileOutput = full
          ? [
            <p className="c_description">{item.description || ''}</p>,
            <p style={{ textAlign: 'center' }}>
              <img
                src={`${item.file_link}` || ''}
                alt={item.original_name || ''}
                style={{ maxWidth: '100%', maxHeight: height }}
              />
            </p>,
          ]
          : [
            <p className="c_description">{item.description || ''}</p>,
            <p className="img_preview">
              <img
                src={`${item.file_link}?w=${width}&h=${height}` || ''}
                alt={item.original_name || ''}
                style={{ maxWidth: '100%', maxHeight: height }}
              />
            </p>,
          ];
        break;
      case 'video':
        this.fileOutput = full
          ? [
            <p className="c_description">{item.description || ''}</p>,
            <p style={{ textAlign: 'center' }}>
              <video width="100%" preload="metadata" controls>
                <source src={item.file_link} type="video/mp4" />
                <track kind="captions" label={item.original_name || ''} />
              </video>
            </p>,
          ]
          : [
            <p className="c_description">{item.description || ''}</p>,
            <p className="video_preview">
              <img
                src={`${item.file_link}?w=${width}&h=${height}` || ''}
                alt={item.original_name || ''}
                style={{ maxWidth: '100%', maxHeight: '100%' }}
              />
            </p>,
          ];
        break;
      case 'audio':
        this.fileOutput = full ? (
          [
            <p className="c_description">{item.description || ''}</p>,
            <p style={{ textAlign: 'center' }}>
              <audio style={{ width: '100%' }} preload="metadata" controls>
                <source src={item.file_link} type="audio/mpeg" />
                <track kind="captions" label={item.original_name || ''} />
              </audio>
            </p>,
          ]
        ) : (
          <p className="c_description">{item.description || ''}</p>
        );
        break;
      case 'text':
        this.fileOutput = full
          ? [
            <p className="c_description">{item.description || ''}</p>,
            <div dangerouslySetInnerHTML={{ __html: item.text }} />,
          ]
          : [<p>{item.description || ''}</p>, getTextFromHtml(item.text || '')];
        break;
      case 'link':
        this.fileOutput = [
          <p className="c_description">
            {item.description ? `${item.description.slice(0, 80)}...` : ''}
          </p>,
          <p style={{ textAlign: 'center' }}>
            <a
              href={item.link}
              rel="noopener noreferrer"
              target="_blank"
              onClick={(e) => {
                e.stopPropagation();
                this.props.hideModal();
              }}
            >
              {item.link}
            </a>
          </p>,
        ];
        break;
      default:
        this.fileOutput = full ? (
          [
            <p className="c_description">{item.description || ''}</p>,
            <p>
              <FormattedMessage id="contents_preview_isNotAvailable" />
              <br />
              <FormattedMessage id="contents_downloadingIsAvailable" />
            </p>,
          ]
        ) : (
          <p className="c_description">{item.description || ''}</p>
        );
    }

    return [
      this.props.permissions.includes('LESSON_CONTENT_PREVIEW')
        ? this.fileOutput
        : '',
      <p>
        {item.size &&
          (item.type === 'document' ||
            item.type === 'image' ||
            item.type === 'video' ||
            item.type === 'audio') &&
          `${Math.round((item.size * 100) / 1024 / 1024) / 100} Mb`}
        {item.duration &&
          (item.type === 'video' || item.type === 'audio') &&
          ` / ${toHHMMSS(item.duration)}`}
      </p>,
    ];
  }

  render() {
    const { page, items } = this.state;
    const { intl, list, total, permissions } = this.props;
    let overflow;
    if (!permissions.includes('LESSON_CONTENT_LIST')) {
      return null;
    }

    if (document.location.href.includes('/contents')) {
      overflow = true;
    } else {
      overflow = false;
    }

    return (
      <div>
        <div className="tiles">
          {list.map((item) => {
            const titleSplited = item.title.split(' ');
            return (
              <div
                key={item.id}
                className={`tile_link ${overflow ? 'title_link_overflow' : ''}`}
                onClick={(e) => {
                  if (item.type === 'text') {
                    loadText(item.id).then(res =>
                      store.dispatch(addModal(
                        1,
                        [this.getPreview(res, 640, 480, true)],
                        res.title,
                        permissions.includes('LESSON_CONTENT_DOWNLOAD_PUBLIC') &&
                        (res.is_private !== 'true'
                          ? res.file_link || ''
                          : false),
                      )));
                  } else {
                    return store.dispatch(addModal(
                      1,
                      [this.getPreview(item, 640, 480, true)],
                      item.title,
                      permissions.includes('LESSON_CONTENT_DOWNLOAD_PUBLIC') &&
                      (item.is_private !== 'true'
                        ? item.file_link || ''
                        : false),
                    ));
                  }
                }}
                role="button"
                tabIndex={item.id}
              >
                <p
                  className={
                    item.type === 'image' || item.type === 'video'
                      ? 'short_title title'
                      : 'title'
                  }
                  style={{ marginBottom: '0px', marginTop: '3px' }}
                >
                  {`${titleSplited.slice(0, 4).join(' ')}${titleSplited.length < 4 ? '' : '...'}`}
                </p>
                <p style={{ margin: '0px' }}>{this.getPreview(item, 110, 110)}</p>
                {/* mobile! */}
                {/* <p style={{maxHeight: '65%'}}>{this.getPreview(item, 128, 128)}</p> */}

                {item.is_private !== 'true' &&
                  item.file_link &&
                  permissions.includes('LESSON_CONTENT_DOWNLOAD_PUBLIC') && (
                    <a
                      href={item.file_link}
                      rel="noopener noreferrer"
                      target="_blank"
                      onClick={e => e.stopPropagation()}
                    >
                      <FormattedMessage id="overall_input_download" />
                    </a>
                  )}
              </div>
            );
          })}
        </div>
        <Col>
          <FormGroup>
            <Pagination
              activePage={page}
              itemsPerPage={items}
              totalItems={total}
              onChange={this.gotoPage}
            />
          </FormGroup>
        </Col>
        <div className="clear10" />
      </div>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(ContentsTraining));



// WEBPACK FOOTER //
// ./src/views/_MyTrainings/Contents/index.js